import { render, staticRenderFns } from "./TaskNew.vue?vue&type=template&id=6c844311&"
import script from "./TaskNew.vue?vue&type=script&lang=js&"
export * from "./TaskNew.vue?vue&type=script&lang=js&"
import style0 from "./TaskNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/var/apps/oil/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c844311')) {
      api.createRecord('6c844311', component.options)
    } else {
      api.reload('6c844311', component.options)
    }
    module.hot.accept("./TaskNew.vue?vue&type=template&id=6c844311&", function () {
      api.rerender('6c844311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TaskNew.vue"
export default component.exports